/**
 * 探索区域选择面板
 */

import type { PlayerState } from '../engine/Player';
import type { Zone } from '../data/zones';
import { getAvailableZones } from '../data/zones';
import { findRealmLevel } from '../data/realms';
import { REALMS } from '../data/realms';

export type ZoneAction = 'enter' | 'close';
export interface ZoneActionPayload { action: ZoneAction; zone?: Zone; }

export class ZonePanel {
  private overlay: HTMLElement | null = null;
  private onAction: ((payload: ZoneActionPayload) => void) | null = null;

  setOnAction(cb: (p: ZoneActionPayload) => void): void { this.onAction = cb; }

  open(player: PlayerState): void {
    if (this.overlay) this.overlay.remove();

    const realmLevel = findRealmLevel(player.realmKey);
    const realmIndex = realmLevel
      ? REALMS.findIndex((r) => r.levels.some((l) => l.key === player.realmKey))
      : 0;

    const zones = getAvailableZones(realmIndex);

    this.overlay = document.createElement('div');
    this.overlay.className = 'modal-overlay';

    const items = zones.map((z) => `
      <div class="zone-card">
        <div style="display:flex;align-items:center;gap:8px;">
          <span style="font-size:1.5em;">${z.icon}</span>
          <div style="flex:1;">
            <div style="font-weight:bold;color:var(--text-gold);">${z.name}</div>
            <div style="font-size:0.8em;color:var(--text-secondary);">${z.desc}</div>
          </div>
        </div>
        <div style="display:flex;gap:12px;font-size:0.75em;margin:8px 0;">
          <span>🌿×${z.herbBonus.toFixed(1)}</span>
          <span>💎×${z.coreBonus.toFixed(1)}</span>
          <span>💰×${z.stoneBonus.toFixed(1)}</span>
          <span>📖×${z.expBonus.toFixed(1)}</span>
          <span style="color:${z.enemyPower > 1 ? 'var(--danger)' : 'var(--text-secondary)'};">⚡×${z.enemyPower.toFixed(1)}</span>
        </div>
        <button class="btn btn-small btn-primary zone-enter" data-zone="${z.id}">进入探索</button>
      </div>
    `).join('');

    this.overlay.innerHTML = `
      <div class="modal" style="max-width:480px;max-height:80vh;overflow-y:auto;">
        <h2>🗺️ 探索区域</h2>
        <p style="color:var(--text-secondary);font-size:0.85em;margin-bottom:12px;">🌿灵草 💎妖丹 💰灵石 📖经验 ⚡危险度</p>
        <div style="display:flex;flex-direction:column;gap:8px;">${items}</div>
        <button class="btn btn-small" id="zone-close" style="margin-top:12px;">关闭</button>
      </div>
    `;

    document.body.appendChild(this.overlay);

    this.overlay.querySelectorAll('.zone-enter').forEach((btn) => {
      btn.addEventListener('click', () => {
        const zoneId = (btn as HTMLElement).dataset.zone!;
        const zone = zones.find((z) => z.id === zoneId);
        if (zone && this.onAction) this.onAction({ action: 'enter', zone });
      });
    });

    document.getElementById('zone-close')?.addEventListener('click', () => {
      this.close();
      if (this.onAction) this.onAction({ action: 'close' });
    });
    this.overlay.addEventListener('click', (e) => {
      if (e.target === this.overlay) { this.close(); if (this.onAction) this.onAction({ action: 'close' }); }
    });
  }

  close(): void { if (this.overlay) { this.overlay.remove(); this.overlay = null; } }
}
